import { Fragment } from 'react'
import { Box, Skeleton, Text, Title } from '@holbonkit/ui'

import type { SbpBank } from '@/shared/api'

import { getItemType } from '../../model/get-item-type'

import { ListItem } from './list-item'

import styles from './list.module.scss'

export type SbpBankWithLetter = SbpBank & { firstLetter: string }

type TListProps = {
    accountId: null | number
    all: SbpBankWithLetter[]
    firstLetters: string[]
    isError: boolean
    isFetchingNextPage: boolean
    isPending: boolean
    onSelect: (bank: SbpBank) => void
    popular: SbpBank[]
    selectedBank: null | SbpBank
}

export const List = ({
    all,
    accountId,
    firstLetters,
    isError,
    isFetchingNextPage,
    isPending,
    onSelect,
    popular,
    selectedBank,
}: TListProps) => {
    if (isPending) {
        return (
            <Box className={styles['list__loading']}>
                <Skeleton style={{ height: 56, borderRadius: 8 }} />
                <Skeleton style={{ height: 56, borderRadius: 8 }} />
                <Skeleton style={{ height: 56, borderRadius: 8 }} />
            </Box>
        )
    }

    if (isError && popular.length === 0 && all.length === 0) {
        return (
            <Box className={styles['list__edit']}>
                <Title variant='header-20-bold'>Ничего не нашли</Title>
                <Text className={styles['list__edit--text']} variant='body-m-16-regular'>
                    Не удалось загрузить список банков
                </Text>
            </Box>
        )
    }

    if (popular.length === 0 && all.length === 0) {
        return (
            <Box className={styles['list__edit']}>
                <Title variant='header-20-bold'>Ничего не нашли</Title>
                <Text className={styles['list__edit--text']} variant='body-m-16-regular'>
                    В списке большинство крупных банков страны, и мы регулярно его обновляем
                </Text>
            </Box>
        )
    }

    return (
        <Box className={styles['list']}>
            {popular.length > 0 && (
                <Text className={styles['list__title']} variant='body-s-14-medium'>
                    Популярные
                </Text>
            )}
            {popular.map((bank) => (
                <ListItem
                    key={bank.id}
                    bank={bank}
                    type={getItemType(bank.id, accountId, selectedBank?.id)}
                    onClick={() => onSelect(bank)}
                />
            ))}
            {firstLetters.map((letter) => (
                <Fragment key={letter}>
                    <Text className={styles['list__title']} variant='body-s-14-medium'>
                        {letter}
                    </Text>
                    {all
                        .filter((bank) => bank.firstLetter === letter)
                        .map((bank) => (
                            <ListItem
                                key={bank.id}
                                bank={bank}
                                type={getItemType(bank.id, accountId, selectedBank?.id)}
                                onClick={() => onSelect(bank)}
                            />
                        ))}
                </Fragment>
            ))}
            {isFetchingNextPage ?
                <Box className={styles['list__loading']}>
                    <Skeleton style={{ height: 24, borderRadius: 8 }} />
                </Box>
            :   null}
            {isError ?
                <Text className={styles['list__edit']} variant='body-m-16-medium'>
                    Не удалось загрузить ещё банки(
                </Text>
            :   null}
        </Box>
    )
}
